import { useRegisterSupportOrganization } from "@/api/services/admin/rso";
import { InnerBox } from "@/components/elements/InnerBox";
import { DATE_FORMAT } from "@/constants/datetime";
import { EMPTY_STR } from "@/constants/string";
import { dayjs } from "@/utils/dayjs";
import { Divider, Grid, Stack, Typography } from "@mui/material";

export const RsoSummary = () => {
  const { data: rsoResult, isLoading: isLoadingRso } = useRegisterSupportOrganization();

  const rsoData = rsoResult?.data;

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Stack gap={2}>
          <InnerBox title={<Typography variant="sub16Bold">登録支援機関情報</Typography>} loading={isLoadingRso}>
            <Typography whiteSpace="pre-line">{rsoData?.description || "----"}</Typography>
          </InnerBox>
          <InnerBox title={<Typography variant="sub16Bold">備考欄（フリーテキスト）</Typography>} loading={isLoadingRso}>
            <Typography whiteSpace="pre-line">{rsoData?.note || "----"}</Typography>
          </InnerBox>
        </Stack>
      </Grid>
      <Grid item xs={6}>
        <InnerBox loading={isLoadingRso} height="100%" justifyContent="center">
          <Stack gap={3}>
            <Stack flexDirection="row" justifyContent="space-evenly" gap={5}>
              {/* TODO(IROHANA_VISA_ESD_DEV-2): 種別 display hidden until design is finalized. The field is
                  still editable in RegisterSupportOrganizationForm — only this readout is hidden. */}
              {/* <Stack alignItems="center" gap={1}>
                <Typography variant="sub16Semi">種別</Typography>
                <Typography variant="head20Bold">
                  {(Array.isArray(rsoData?.organizationType) ? rsoData.organizationType : [])
                    .map((type) => findLabelByValue(organizationTypeOptions, type))
                    .filter(Boolean)
                    .join("・") || EMPTY_STR.TEXT}
                </Typography>
              </Stack> */}
              <Stack alignItems="center" gap={1}>
                <Typography variant="sub16Semi">契約プラン</Typography>
                <Typography variant="head20Bold">{rsoData?.contractPlan ? rsoData?.contractPlan : EMPTY_STR.TEXT}</Typography>
              </Stack>
              <Stack alignItems="center" gap={1}>
                <Typography variant="sub16Semi">契約開始日</Typography>
                <Typography variant="head20Bold">
                  {rsoData?.contractStartDate ? dayjs(rsoData?.contractStartDate).format(DATE_FORMAT) : EMPTY_STR.DATE}
                </Typography>
              </Stack>
              <Stack alignItems="center" gap={1}>
                <Typography variant="sub16Semi">解約日</Typography>
                <Typography variant="head20Bold">
                  {rsoData?.contractEndDate ? dayjs(rsoData?.contractEndDate).format(DATE_FORMAT) : EMPTY_STR.DATE}
                </Typography>
              </Stack>
            </Stack>
            <Divider sx={{ mt: 3 }} />
            <Stack direction="row" height="100%" gap={4} justifyContent="center" alignItems="start">
              <Stack gap={1}>
                <Typography variant="sub16Semi">所属機関数</Typography>
                <Typography variant="head32Bold" textAlign="center">
                  {rsoResult?.data.companyCount || 0}社
                </Typography>
              </Stack>
              <Stack gap={1}>
                <Typography variant="sub16Semi">最大課金対象数</Typography>
                <Typography variant="head32Bold" textAlign="center">
                  {rsoData?.currentMonthMaxBillableEmployeeCount ?? EMPTY_STR.TEXT}人
                </Typography>
                <Typography fontSize={12} color="text.secondary" textAlign="center">
                  {rsoData?.currentMonthMaxBillableEmployeeCountDate
                    ? dayjs(rsoData?.currentMonthMaxBillableEmployeeCountDate).format(DATE_FORMAT)
                    : EMPTY_STR.DATE}
                </Typography>
              </Stack>
              <Stack gap={1}>
                <Typography variant="sub16Semi">前回課金対象数</Typography>
                <Typography variant="head32Bold" textAlign="center">
                  {rsoData?.previousMonthMaxBillableEmployeeCount ?? EMPTY_STR.TEXT}人
                </Typography>
                <Typography fontSize={12} color="text.secondary" textAlign="center">
                  {rsoData?.previousMonthMaxBillableEmployeeCountDate
                    ? dayjs(rsoData?.previousMonthMaxBillableEmployeeCountDate).format(DATE_FORMAT)
                    : EMPTY_STR.DATE}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </InnerBox>
      </Grid>
    </Grid>
  );
};
